<!-- category-tree.component.html -->
<ul class="ml-4 border-l border-gray-300 pl-4">
  <li *ngFor="let category of categories" class="mb-2">
    <div class="flex items-center space-x-2">
      <!-- Expand/Collapse -->
      <button *ngIf="category.children && (category.children?.length ?? 0) > 0"
              (click)="toggleExpand(category)"
              class="text-gray-600 focus:outline-none">
        <span *ngIf="!category.expanded">➕</span>
        <span *ngIf="category.expanded">➖</span>
      </button>

      <!-- Category Name -->
      <span class="font-medium text-gray-800">
        {{ category.name }}
      </span>

      <!-- Status -->
      <span [class.bg-green-200]="category.isActive"
            [class.bg-red-200]="!category.isActive"
            class="text-xs px-2 py-1 rounded">
        {{ category.isActive ? 'Active' : 'Inactive' }}
      </span>

      <!-- Actions -->
      <button (click)="toggleAddForm(category.id)" class="text-green-600 text-sm hover:underline">
        + Subcategory
      </button>

      <button (click)="addProduct(category.id)"
              class="text-purple-600 text-sm hover:underline">
        + Product
      </button>

      <button class="text-blue-600 text-sm hover:underline">Edit</button>
      <button class="text-red-600 text-sm hover:underline">Delete</button>
    </div>

    <!-- Inline Add Form -->
    <div *ngIf="showAddForm[category.id]" class="ml-6 mt-2">
      <input type="text"
             [(ngModel)]="newCategoryName[category.id]"
             placeholder="Subcategory name"
             class="border px-2 py-1 rounded w-64" />
      <button (click)="addSubcategory(category.id)"
              class="ml-2 bg-blue-600 text-white px-3 py-1 rounded">
        Save
      </button>
      <button (click)="toggleAddForm(category.id)"
              class="ml-2 text-gray-500 text-sm">
        Cancel
      </button>
    </div>

    <!-- Recursive Children -->
    <div *ngIf="category.children && category.children.length > 0 && category.expanded">
      <app-category-tree [categories]="category.children"></app-category-tree>
    </div>
  </li>
</ul>
